import { getApolloClient } from '../lib/getApolloClient';
import {
  AGREE_TO_POLICY,
  GET_POLICIES_BY_OWNER_ID,
  GET_POLICY,
} from './policy.gql';
import { Policy } from '../generated/gql-types';

const getPoliciesByOwnerId = async (ownerId: string): Promise<Policy[]> => {
  try {
    const { data } = await getApolloClient().query({
      query: GET_POLICIES_BY_OWNER_ID,
      variables: {
        ownerId: ownerId,
      },
    });

    if (!data?.getPoliciesByOwnerId) {
      throw new Error('Failed to get policies by owner id');
    }
    return data.getPoliciesByOwnerId;
  } catch (error) {
    console.error('Error getting policies by owner id:', error);
    throw error;
  }
};

const fetchPolicyById = async (policyId: string): Promise<Policy> => {
  const { data } = await getApolloClient().query({
    query: GET_POLICY,
    variables: { id: policyId },
    fetchPolicy: 'network-only',
  });

  if (!data?.getPolicy) {
    throw new Error('Failed to get policy');
  }
  return data.getPolicy;
};

const agreeToPolicy = async (policyId: string): Promise<Policy> => {
  try {
    const { data } = await getApolloClient().mutate({
      mutation: AGREE_TO_POLICY,
      variables: {
        policyId: policyId,
      },
    });
    if (!data?.agreeToPolicy) {
      throw new Error('Failed to agree to policy');
    }
    return data.agreeToPolicy;
  } catch (error) {
    console.error('Error agreeing to policy:', error);
    throw error;
  }
};

export const policyActions = {
  getPoliciesByOwnerId,
  fetchPolicyById,
  agreeToPolicy,
};
